module.exports = __webpack_public_path__ + "img/cover_lead.e9b8c7b6.png";